/* eslint-disable react/no-unused-state */
import React from "react"
import { Col, Row } from "antd"
import { CodeSnippet, ProgramNameDisplay, ProgramConversionContainer } from "./HelperComponents"
import { Typography } from "@mui/material";
import { Link as GatsbyLink } from "gatsby"
import { styled } from '@mui/system';

const Link = styled(props => <GatsbyLink {...props} />)({
  color: "#69c",
  textDecoration: "none",
  "&:hover": { color: "#8fc9ff" }
})

const ProgrammingEpochToHumanReadableConversion = () => {
  return (
    <div id={"programmingEpochToHumanReadableConversion"}>
      <Row style={{ marginTop: "50px" }}>
        <Col>
          <Typography variant={`h2`}
            style={{
              // color: "#4d3267",
              fontSize: "24px",
              fontWeight: "bold",
              fontFamily: "Karla, sans-serif"
            }}
          >
            Convert from epoch to human-readable date
          </Typography>
        </Col>
      </Row>
      <Row style={{ margin: "30px 0 0 1px", width: "70%" }} gutter={8}>
        <ProgramConversionContainer>
          <ProgramNameDisplay children={"PHP"}/>
          <Col span={18}>
            <CodeSnippet>date(output format, epoch);</CodeSnippet>
            <span style={{ fontSize: "15px" }}>Output format example: 'r' = RFC 2822 date</span>
          </Col>
        </ProgramConversionContainer>

        <ProgramConversionContainer>
          <ProgramNameDisplay children={"Python"}/>
          <Col span={18}>
            <CodeSnippet>import time; time.strftime("%a, %d %b %Y %H:%M:%S +0000", time.localtime(epoch))</CodeSnippet>
            <span
              style={{ fontSize: "15px" }}>Replace time.localtime with time.gmtime for GMT time. Or using datetime:</span>
            <CodeSnippet>import datetime;
              datetime.datetime.utcfromtimestamp(epoch).replace(tzinfo=datetime.timezone.utc)</CodeSnippet>
          </Col>
        </ProgramConversionContainer>

        <ProgramConversionContainer>
          <ProgramNameDisplay children={"Ruby"}/>
          <Col span={18}>
            <CodeSnippet>Time.at(epoch)</CodeSnippet>
          </Col>
        </ProgramConversionContainer>

        {/*<ProgramConversionContainer>*/}
        {/*  <ProgramNameDisplay children={"Perl"}/>*/}
        {/*  <Col span={18}>*/}
        {/*    <span style={{ fontSize: "15px" }}>Use the Perl Epoch routines</span>*/}
        {/*  </Col>*/}
        {/*</ProgramConversionContainer>*/}

        <ProgramConversionContainer>
          <ProgramNameDisplay children={"Java"}/>
          <Col span={18}>
            <CodeSnippet>String date = new java.text.SimpleDateFormat("MM/dd/yyyy HH:mm:ss").format(new java.util.Date
              (epoch*1000));</CodeSnippet>
            <span style={{ fontSize: "15px" }}>Epoch in seconds, remove '*1000' for milliseconds.</span>
          </Col>
        </ProgramConversionContainer>

        <ProgramConversionContainer>
          <ProgramNameDisplay children={"Lua"}/>
          <Col span={18}>
            <CodeSnippet>datestring = os.date([format[,epoch]])</CodeSnippet>
          </Col>
        </ProgramConversionContainer>

        <ProgramConversionContainer>
          <ProgramNameDisplay children={"VBScript/ASP"}/>
          <Col span={18}>
            <CodeSnippet>DateAdd("s", epoch, "01/01/1970 00:00:00")</CodeSnippet>
          </Col>
        </ProgramConversionContainer>

        <ProgramConversionContainer>
          <ProgramNameDisplay children={"AutoIT"}/>
          <Col span={18}>
            <CodeSnippet>_DateAdd("s", $EpochSeconds , "1970/01/01 00:00:00")</CodeSnippet>
          </Col>
        </ProgramConversionContainer>

        <ProgramConversionContainer>
          <ProgramNameDisplay children={"Delphi"}/>
          <Col span={18}>
            <CodeSnippet>myString := DateTimeToStr(UnixToDateTime(Epoch));</CodeSnippet>
            <span style={{ fontSize: "15px" }}>Where Epoch is a signed integer.</span>
          </Col>
        </ProgramConversionContainer>

        <ProgramConversionContainer>
          <ProgramNameDisplay children={"C"}/>
          <Col span={18}>
            <CodeSnippet>ts = *localtime(&rawtime);
              strftime(buf, sizeof(buf), "%a %Y-%m-%d %H:%M:%S %Z", &ts);
              printf("%s\n", buf);</CodeSnippet>
          </Col>
        </ProgramConversionContainer>

        <ProgramConversionContainer>
          <ProgramNameDisplay children={"Objective-C"}/>
          <Col span={18}>
            <CodeSnippet>NSDate * myDate = [NSDate dateWithTimeIntervalSince1970:epoch]; NSLog(@"%@",
              date);</CodeSnippet>
          </Col>
        </ProgramConversionContainer>

        <ProgramConversionContainer>
          <ProgramNameDisplay children={"R"}/>
          <Col span={18}>
            <CodeSnippet> as.POSIXct(epoch, origin="1970-01-01", tz="GMT")</CodeSnippet>
          </Col>
        </ProgramConversionContainer>

        <ProgramConversionContainer>
          <ProgramNameDisplay children={"Go"}/>
          <Col span={18}>
            <span style={{ fontSize: "15px" }}><Link to={"https://play.golang.org/p/6h0A0WPxtq"} rel={"noreferrer"}
                                                  target={"blank"}>Example code</Link></span>
          </Col>
        </ProgramConversionContainer>

        <ProgramConversionContainer>
          <ProgramNameDisplay children={"Adobe ColdFusion"}/>
          <Col span={18}>
            <CodeSnippet>DateAdd("s",epoch,"1/1/1970");</CodeSnippet>
          </Col>
        </ProgramConversionContainer>

        <ProgramConversionContainer>
          <ProgramNameDisplay children={"MySQL"}/>
          <Col span={18}>
            <CodeSnippet>FROM_UNIXTIME(epoch, optional output format)</CodeSnippet>
            <span style={{ fontSize: "15px" }}>Default output format is YYY-MM-DD HH:MM:SS. If you need support for negative timestamps: </span>
            <CodeSnippet>DATE_FORMAT(DATE_ADD(FROM_UNIXTIME(0), interval -315619200 second),"%Y-%m-%d")</CodeSnippet>
            <span style={{ fontSize: "15px" }}>(replace -315619200 with epoch)</span>
          </Col>
        </ProgramConversionContainer>

        <ProgramConversionContainer>
          <ProgramNameDisplay children={"PostgreSQL"}/>
          <Col span={18}>
            <span style={{ fontSize: "15px" }}>PostgreSQL version 8.1 and higher:</span>
            <CodeSnippet>SELECT to_timestamp(epoch);</CodeSnippet>
            <span style={{ fontSize: "15px" }}><Link
              to={"https://www.postgresql.org/docs/current/static/functions-formatting.html"} rel={"noreferrer"}
              target={"blank"}> Older versions:</Link></span>
            <CodeSnippet>SELECT TIMESTAMP WITH TIME ZONE 'epoch' + epoch * INTERVAL '1 second';</CodeSnippet>
          </Col>
        </ProgramConversionContainer>

        <ProgramConversionContainer>
          <ProgramNameDisplay children={"SQLite"}/>
          <Col span={18}>
            <CodeSnippet>SELECT datetime(epoch_to_convert, 'unixepoch');</CodeSnippet>
            <span style={{ fontSize: "15px" }}>or local timezone:</span>
            <CodeSnippet>SELECT datetime(epoch_to_convert, 'unixepoch', 'localtime');</CodeSnippet>
          </Col>
        </ProgramConversionContainer>

        <ProgramConversionContainer>
          <ProgramNameDisplay children={"Oracle PL/SQL"}/>
          <Col span={18}>
            <CodeSnippet>SELECT to_date('01-JAN-1970','dd-mon-yyyy')+(1526357743/60/60/24) from dual</CodeSnippet>
            <span style={{ fontSize: "15px" }}>Replace 1526357743 with epoch.</span>
          </Col>
        </ProgramConversionContainer>

        <ProgramConversionContainer>
          <ProgramNameDisplay children={"SQL Server"}/>
          <Col span={18}>
            <CodeSnippet>DATEADD(s, epoch, '1970-01-01 00:00:00')</CodeSnippet>
          </Col>
        </ProgramConversionContainer>

        <ProgramConversionContainer>
          <ProgramNameDisplay children={"IBM Informix"}/>
          <Col span={18}>
            <CodeSnippet>SELECT dbinfo('utc_to_datetime',epoch) FROM sysmaster:sysdual;</CodeSnippet>
          </Col>
        </ProgramConversionContainer>

        <ProgramConversionContainer>
          <ProgramNameDisplay children={"Microsoft Excel / LibreOffice Calc"}/>
          <Col span={18}>
            <CodeSnippet>=(A1 / 86400) + 25569</CodeSnippet>
            <span style={{ fontSize: "15px" }}>Format the result cell for date/time, the result will be in GMT time (A1 is the cell with the epoch number). For other time zones: =((A1 +/- time zone adjustment) / 86400) + 25569.</span>
          </Col>
        </ProgramConversionContainer>

        <ProgramConversionContainer>
          <ProgramNameDisplay children={"Crystal Reports"}/>
          <Col span={18}>
            <CodeSnippet>{"DateAdd(\"s\", {EpochTimeStampField}-14400, #1/1/1970 00:00:00#)"}</CodeSnippet>
            <span style={{ fontSize: "15px" }}>-14400 used for Eastern Standard Time. </span>
          </Col>
        </ProgramConversionContainer>

        <ProgramConversionContainer>
          <ProgramNameDisplay children={"JavaScript"}/>
          <Col span={18}>
            <CodeSnippet>{"var myDate = new Date( your epoch date *1000); document.write(myDate.toGMTString()+\"-------\"+myDate.toLocaleString());"}</CodeSnippet>
          </Col>
        </ProgramConversionContainer>

        <ProgramConversionContainer>
          <ProgramNameDisplay children={"Tcl/Tk"}/>
          <Col span={18}>
            <CodeSnippet>clock format 1325376000</CodeSnippet>
            <span style={{ fontSize: "15px" }}><Link to={"https://www.tcl.tk/man/tcl8.6/TclCmd/clock.htm"}
                                                  rel={"noreferrer"} target={"blank"}>For More Tcl/Tk snippets</Link></span>
          </Col>
        </ProgramConversionContainer>

        <ProgramConversionContainer>
          <ProgramNameDisplay children={"MATLAB"}/>
          <Col span={18}>
            <CodeSnippet>datestr(719529+TimeInSeconds/86400,'dd-mmm-yyyy HH:MM:SS')</CodeSnippet>
          </Col>
        </ProgramConversionContainer>

        <ProgramConversionContainer>
          <ProgramNameDisplay children={"IBM PureData System for Analytics"}/>
          <Col span={18}>
            <CodeSnippet>select 996673954::int4::abstime::timestamp;</CodeSnippet>
          </Col>
        </ProgramConversionContainer>

        <ProgramConversionContainer>
          <ProgramNameDisplay children={"Unix/Linux Shell"}/>
          <Col span={18}>
            <CodeSnippet>date -d @1520000000</CodeSnippet>
            <span style={{ fontSize: "15px" }}>Replace 1520000000 with your epoch, needs recent version of 'date'. Replace '-d' with '-ud' for GMT/UTC time.</span>
          </Col>
        </ProgramConversionContainer>

        <ProgramConversionContainer>
          <ProgramNameDisplay children={"Mac OS X"}/>
          <Col span={18}>
            <CodeSnippet>date -j -r 1520000000</CodeSnippet>
          </Col>
        </ProgramConversionContainer>

        <ProgramConversionContainer>
          <ProgramNameDisplay children={"PowerShell"}/>
          <Col span={18}>
            <CodeSnippet>{"Function get-epochDate ($epochDate) { [timezone]::CurrentTimeZone.ToLocalTime(([datetime]'1/1/1970').AddSeconds($epochDate)) }"}</CodeSnippet>
            <span style={{ fontSize: "15px" }}>, then use:</span>
            <CodeSnippet>get-epochDate 1520000000.</CodeSnippet>
            <span style={{ fontSize: "15px" }}>Works for Windows PowerShell v1 and v2</span>
          </Col>
        </ProgramConversionContainer>

        <ProgramConversionContainer>
          <ProgramNameDisplay children={"Other OS's"}/>
          <Col span={18}>
            <span style={{ fontSize: "15px" }}>Command line:</span>
            <CodeSnippet>perl -e "print scalar(localtime(epoch))"</CodeSnippet>
            <span style={{ fontSize: "15px" }}>(If Perl is installed) Replace 'localtime' with 'gmtime' for GMT/UTC time.</span>
          </Col>
        </ProgramConversionContainer>
      </Row>
    </div>
  )
}

export default ProgrammingEpochToHumanReadableConversion
